package user.components

import antd.KeyboardEvent
import antd.MouseEvent
import antd.button.button
import react.*
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.grid.row
import antd.grid.col
import antd.message.message
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.browser.localStorage
import kotlinx.browser.window
import user.containers.LoginPageContext
import org.w3c.dom.events.Event
import org.w3c.dom.HTMLInputElement
import react.dom.*
import urlBase

external interface  LoginState:RState {
    var userName:String// = ""
    var password:String// = ""
    var height :Int// = 600
    var width:Int// = 800
}

external interface LoginComponentProps:RProps {
    var loginCallback:(userName:String,password:String)->Unit
    var onTyping:()->Unit
}

const val KEY_LAST_LOGIN_ORGANIZATION_NAME = "KEY_LAST_LOGIN_ORGANIZATION_NAME"
const val KEY_LAST_LOGIN_USER_NAME = "KEY_LAST_LOGIN_USER_NAME"

@JsExport
class LoginComponent : RComponent<LoginComponentProps, LoginState>() {
    init {
        //state = LoginState()
        state.userName = ""
        state.password = ""
        state.height = 600
        state.width = 800
    }
    override fun componentDidMount() {
        val defaultOrgName = localStorage.getItem(KEY_LAST_LOGIN_ORGANIZATION_NAME)
        val defaultUserName = localStorage.getItem(KEY_LAST_LOGIN_USER_NAME)
        console.log("KEY_LAST_LOGIN_ORGANIZATION_NAME",defaultOrgName)

        setState{
            width  = window.innerWidth
            height = window.innerHeight
            userName = defaultUserName?:""
        }
        window.addEventListener("resize", ::updateWindowDimensions)
    }

    fun updateWindowDimensions(event:Event) {
        setState{
            width  = window.innerWidth
            height = window.innerHeight
        }
    }

    fun onSubmit(event: MouseEvent<Any>?){
        console.log("submiting...",state.userName,state.password)
        props.loginCallback(state.userName,state.password);
    }

    fun onKeyPress(event: KeyboardEvent<HTMLInputElement>){
        if (event.which == 13 || event.key == "Enter") {
            // Cancel the default action, if needed
            event.preventDefault();
            //trigger submit
            onSubmit(null)
        }
    }

    override fun RBuilder.render() {
        LoginPageContext.Consumer { errorMsg ->

            console.log("consumer received",errorMsg)

            if (!errorMsg.isBlank()){
                message.error("登录失败：$errorMsg")
            }

            div{
                attrs {
                    jsStyle = js{margin = "0";padding="0"}
                }
                div("login-header") {
                    attrs {
                        jsStyle = js {
                            width = "${state.width}px"
                            height = "80px"
                            lineHeight = "80px"
                        }
                    }
                    p{
                        attrs{
                            jsStyle = js{
                                textAlign = "center"
                            }
                        }

                        h2{
                            attrs{
                                jsStyle {
                                    color = "white"
                                }
                            }
                            +"经方派　　"
                        }

                    }
                }

                div {
                    attrs {
                        jsStyle = js {
                            position = "relative"
                            width = "${state.width}px"
                            height = "600px"
                            //backgroundImage = "url('${urlBase}/images/login/login_bg.png')"
                        }
                    }
                    div {
                        attrs{
                            jsStyle = js{
                                width = "80%"
                                //height = "400px"
                                position = "absolute"
                                top = "50%"
                                left = "50%"
                                transform = "translate(-50%, -50%)"
                                textAlign = "center"
                            }
                        }
                        row {
                            col {
                                attrs {
                                    span = "3"
                                }
                            }
                            col {
                                attrs {
                                    span = "8"
                                    style = js{
                                        backgroundImage = "url('${urlBase}/images/login/login_decorate.png')"
                                    }
                                }
                            }
                            col {
                                attrs {
                                    span = "2"
                                }
                            }
                            col {
                                attrs {
                                    span = "8"
                                    style = js{
                                        background = "white"
                                        padding = "30px"
                                    }
                                }

                                form {
                                    attrs {
                                        name = "login"
                                        labelCol = jsObject {
                                            span = "3"
                                            pull = "left"
                                        }
                                    }

                                    formItem {
                                        attrs {
                                            label = "用户名"
                                        }
                                        input {
                                            attrs {
                                                value = state.userName
                                                name = "userName"
                                                size = "large"
                                                placeholder = "请输入用户名"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    val _u = js("event.target.value")
                                                    localStorage.setItem(KEY_LAST_LOGIN_USER_NAME,_u)
                                                    setState{userName = _u}
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "密码"
                                        }
                                        input {
                                            attrs {
                                                value = state.password
                                                name = "password"
                                                type = "password"
                                                size = "large"
                                                placeholder = "请输入密码"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    setState{password = js("event.target.value")}
                                                }
                                                onKeyPress = ::onKeyPress
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            wrapperCol = jsObject {
                                                span = "20"
                                                offset = "18"
                                            }
                                        }
                                        button {
                                            attrs {
                                                type = "primary"
                                                onClick = ::onSubmit
                                            }
                                            +"登录"
                                        }
                                    }
                                }

                            }
                            col {
                                attrs {
                                    span = "3"
                                }
                            }
                        }
                    }
                }

            }
        }
    }
}

fun RBuilder.loginComponent(loginCallback:(userName:String,password:String)->Unit,onTyping:()->Unit) = child(LoginComponent::class) {
    attrs.loginCallback = loginCallback
    attrs.onTyping = onTyping
}

